import { render, staticRenderFns } from "./UserDetailHeader.vue?vue&type=template&id=26b46ab2&scoped=true&"
import script from "./UserDetailHeader.vue?vue&type=script&lang=ts&"
export * from "./UserDetailHeader.vue?vue&type=script&lang=ts&"
import style0 from "./UserDetailHeader.vue?vue&type=style&index=0&id=26b46ab2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b46ab2",
  null
  
)

export default component.exports